import { Middleware, UnknownAction } from '@reduxjs/toolkit';

import { RootState } from '@/shared/types/state';

import { PUSH_MODAL } from './actions';

type OnModalOpened = (kind: string) => void;

let onModalOpened: OnModalOpened | null = null;

/** Injected, not imported: importing `segment.ts` here would close a cycle. */
export const registerModalOpened = (fn: OnModalOpened) => {
  onModalOpened = fn;
};

/** Reports `Modal Opened` from the action, so no component tracks it. */
export const modalsMiddleware: Middleware<unknown, RootState> =
  () => (next) => (action: UnknownAction) => {
    const result = next(action);

    if (action.type === PUSH_MODAL && onModalOpened) {
      onModalOpened(String(action.kind));
    }

    return result;
  };
